import { render, staticRenderFns } from "./CalculatorTable.vue?vue&type=template&id=224f319e&scoped=true&"
import script from "./CalculatorTable.vue?vue&type=script&lang=ts&"
export * from "./CalculatorTable.vue?vue&type=script&lang=ts&"
import style0 from "./CalculatorTable.vue?vue&type=style&index=0&id=224f319e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224f319e",
  null
  
)

export default component.exports